import React from 'react'
import PropTypes from 'prop-types'
import { linkStyle } from './TranslateToggle'

const LinkSpiedini = () => {
  return (
    <span>
      <a
        style={linkStyle}
        target="_blank"
        rel="noopener noreferrer"
        href={'https://spiedinigrill.com/'}
      >
        {'Spiedini Grills'}
      </a>
    </span>
  )
}
export const localeProps = PropTypes.oneOf(['/', 'en-ca', 'en-us', 'fr-ca'])

LinkSpiedini.propTypes = {}
LinkSpiedini.defaultProps = {}

export default LinkSpiedini
